//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FlagIcon from '../common/FlagIcon';

/*
|---------------------------------------------------------------------
| Language Switcher Component
|---------------------------------------------------------------------
|
| Locale menu to choose the language based on the locales present in
| vue-i18n locales available array
|
*/
export default {
  components: {
    FlagIcon: FlagIcon
  },
  props: {
    // Show dropdown arrow
    showArrow: {
      type: Boolean,
      default: false
    },
    // Show the country label
    showLabel: {
      type: Boolean,
      default: true
    },
    isMini: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentLocale: function currentLocale() {
      var _this = this;
      return this.$i18n.locales.find(function (i) {
        return i.code === _this.$i18n.locale;
      });
    },
    availableLocales: function availableLocales() {
      var _this2 = this;
      return this.$i18n.locales.filter(function (i) {
        return i.code !== _this2.$i18n.locale;
      });
    }
  }
};